import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { AuthService } from '../services/auth.service';
import { first, map } from 'rxjs/operators';
import { ROLES } from '../constant/constant';

export const adminAccessGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  return authService.getBackendUserData().pipe(
    first(user => user !== null), // Wait for the first non-null value
    map(user => {
      if (user?.isAdmin && [ROLES['Manager'], ROLES['Owner']].includes(user?.role)) {
        return true;
      } else {
        router.navigate(['dashboard']);
        return false;
      }
    })
  );
};